import {useEffect, useState} from "react";
import * as Sentry from "@sentry/react";
import {User} from "../../../../api/accessControl/User.ts";
import {BackendApi} from "../../../../api/api.ts";
import Shell from "../../../../components/specific/Shell.tsx";
import {TaxHistoryView, TaxPayment} from "../../../../components/specific/taxHistory";
import {useNotifications} from "../../../../lib/NotificationContext.tsx";

export default function TaxesPage({currentUser}: { currentUser: User }) {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [taxHistory, setTaxHistory] = useState<TaxPayment[]>([]);
    const api = new BackendApi(currentUser.getToken());
    const {dispatch} = useNotifications();

    async function onLoad() {
        try {
            setTaxHistory(await api.Business__tax__history(currentUser.businesses[0]));
        } catch (error) {
            Sentry.captureException(error);
            dispatch({
                title: "Fout opgetreden",
                description: "De belastinggeschiedenis kon niet worden geladen.",
                type: "error",
            });
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        onLoad();
    }, []);

    return (
        <Shell currentUser={currentUser} isLoading={isLoading} title="Belastinggeschiedenis">
            <TaxHistoryView payments={taxHistory}/>
        </Shell>
    );
}
